import { http } from './request'

/** 站内信全部标记已读 */
export async function markAllMessagesRead(): Promise<void> {
  await http.post<void>('/sys/index/message/allMessageMarkRead')
}
